import { StatusData, FacultyData, BlockDayData, BlockDayFacultyData, YearlyData, BlockStatusFacultyData, YearlySummary, Statistik9Data, BlockmonthData, BlockmonthFacultyData } from "modules/statistic";
import { statistic1 } from "services/statistic/statistic1";
import { statistic2 } from "services/statistic/statistic2";
import { statistic3 } from "services/statistic/statistic3";
import { statistic4 } from "services/statistic/statistic4";
import { statistic5 } from "services/statistic/statistic5";
import { statistic6 } from "services/statistic/statistic6";
import { statistic7 } from "services/statistic/statistic7";
import { statistic8 } from "services/statistic/statistic8";
import { statistic9 } from "services/statistic/statistic9";

export const months = ["Jan", "Feb", "März", "April", "Mai", "Juni", "Juli", "Aug", "Sep", "Okt", "Nov", "Dez"];

export const weekDays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag'];

export const generateCSVContent = (headers: string[],
  rows: (string | number)[][]): string => {
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(',')),
  ].join('\n');
  return csvContent;
};

export const downloadFile = (content: string, fileName: string) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



export const downloadAllData = async (startDate = "", endDate = "") => {
  const allData: (string | number)[][] = [];

  try {
    const res1 = await statistic1(startDate, endDate);
    const statusData: StatusData = res1.status_data;
    const yearlyData: YearlyData = res1.yearly_data;

    if (statusData || yearlyData) {
      const headers1 = [
        "Kategorie", "Monat", ...months, "Gesamt", "Kundengruppen anteil"
      ];
      allData.push(["Anlage 1"]);
      allData.push(headers1);
    }

    if (yearlyData) {
      Object.entries(yearlyData).forEach(([year, types]) => {
        Object.entries(types).forEach(([type, data]) => {
          const row = [
            type,
            year,
            ...months.map(
              (_, monthIndex) =>
                (data as { months: { [key: number]: number } }).months[
                monthIndex + 1
                ] || 0
            ),
            (data as { total: number }).total,
            `${(data as { percentage: number }).percentage}%`,
          ];
          allData.push(row);
        });
      });
    }

    if (statusData) {
      Object.entries(statusData).forEach(([status, years]) => {
        Object.entries(years).forEach(([year, data]) => {
          const row = [
            status,
            year,
            ...months.map(
              (_, monthIndex) =>
                (data as { months: { [key: number]: number } }).months[
                monthIndex + 1
                ] || 0
            ),
            (data as { total: number }).total,
            `${(data as { percentage: number }).percentage}%`,
          ];
          allData.push(row);
        });
      });
    }

    allData.push([]);

    const res2 = await statistic2(startDate, endDate);
    const facultyData: FacultyData = res2.faculty_data;

    if (facultyData) {
      const headers2 = [
        "Kategorie", "Monat", ...months, "Gesamt", "Kundengruppen anteil"
      ];

      allData.push(["Anlage 1b"]);
      allData.push(headers2);
      Object.entries(facultyData).forEach(([faculty, years]) => {
        Object.entries(years).forEach(([year, data]) => {
          const row = [
            faculty,
            year,
            ...months.map((_, monthIndex) => data.months[monthIndex + 1] || 0),
            data.total,
            data.percentage + "%"
          ];
          allData.push(row);
        });
      });
    }

    allData.push([]);

    const res3 = await statistic3(startDate, endDate);
    const blockData: BlockDayData = res3.data;
    if (blockData) {
      const headers3 = ['Block', ...weekDays, 'Gesamt', 'Jahr'];

      allData.push(["Anlage 2"]);
      allData.push(headers3);
      Object.entries(blockData).forEach(([block, years]) => {
        Object.entries(years)
          .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
          .forEach(([year, data]) => {
            const row = [
              block,
              ...weekDays.map((day) => data.days[day] || 0),
              data.total,
              year,
            ];
            allData.push(row);
          });
      });
    }

    allData.push([]);

    const res4 = await statistic4(startDate, endDate);
    const blockData4: BlockDayFacultyData = res4.data;

    if (blockData4) {
      const headers3 = ['Block', ...weekDays, 'Gesamt', 'Jahr'];

      allData.push(["Anlage 2b"]);
      allData.push(headers3);

      Object.entries(blockData4).forEach(([block, years]) => {
        Object.entries(years)
          .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
          .forEach(([year, data]) => {
            const row = [
              block,
              ...weekDays.map((day) => data.days[day]?.total || 0),
              data.total || 0,
              year,
            ];
            allData.push(row);
          });
      });
    }

    const res5 = await statistic5(startDate, endDate);
    const blockData5: BlockStatusFacultyData = res5.data;

    const blockSet = new Set<string>();
    Object.entries(blockData5).forEach(([status, yearData]) => {
      Object.entries(yearData).forEach(([year, yearData]) => {
        yearData.blocks.forEach((block) => {
          blockSet.add(block.block);
        });
      });
    });

    const blocks = Array.from(blockSet).sort();
    if (blockData5) {
      const headers5 = ['Status', 'Jahr', ...blocks.flatMap((block) => [
        `Block ${block}`,
        `Alter bis 1 Jahr`
      ]), 'Gesamt', 'Alter bis 1 Jahr', 'in % v. Gesamt', 'Kundengruppen Anteil'];

      allData.push(["Anlage 3"]);
      allData.push(headers5);

      Object.entries(blockData5).forEach(([status, yearsData]) => {
        const currentYear = Math.max(...Object.keys(yearsData).map(Number));

        Object.entries(yearsData)
          .filter(([year]) => status && year)
          .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
          .forEach(([year, yearData]) => {
            const row = [
              status,
              year,
              ...blocks.flatMap((block) => {
                const blockDataForYear = yearData.blocks.find((b) => b.block === block);

                return [
                  blockDataForYear ? blockDataForYear.total_bookings : 0,
                  blockDataForYear ? blockDataForYear.under_one_year : 0
                ];
              }),
              yearData.total,
              yearData.under_one_year,
              yearData.percentage_under_one_year.toFixed(2),
              (yearData.percentage ?? 0).toFixed(2)
            ];

            allData.push(row);
          });
      });

      allData.push([]);
    }



    const res6 = await statistic6(startDate, endDate);
    const blockData6: BlockStatusFacultyData = res6.data;
    const blocks6: string[] = res6.blocks;
    const yearlySummary: YearlySummary = res6.yearlySummary;
    if (blockData6) {
      const headers6 = [
        'Faculty', 'Year',
        ...blocks6.flatMap((block) => [
          `Block ${block}`,
          `Alter bis 1 Jahr`
        ]),
        'Gesamt', 'Alter bis 1 Jahr', 'in % v. Gesamt', 'Kundengruppen Anteil'
      ];
      allData.push(["Anlage 3b"]);
      allData.push(headers6);

      Object.entries(yearlySummary)
        .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
        .forEach(([year, summaryData]) => {
          const row = [
            'gesamt',
            year,
            ...blocks.flatMap((block) => {
              const blockSummary = summaryData.blocks.find((b) => b.block === block) || {
                total_bookings: 0,
                under_one_year: 0
              };
              return [
                blockSummary.total_bookings,
                blockSummary.under_one_year
              ];
            }),
            summaryData.total,
            summaryData.under_one_year,
            (summaryData.percentage_under_one_year ?? 0).toFixed(2),
            '100%'
          ];
          allData.push(row);
        });

      Object.entries(blockData6).forEach(([faculty, yearsData]) => {
        const currentYear = Math.max(...Object.keys(yearsData).map(Number));

        Object.entries(yearsData)
          .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
          .forEach(([year, yearData]) => {
            const row = [
              faculty,
              year,
              ...blocks.flatMap((block) => {
                const blockDataForYear = yearData.blocks.find((b) => b.block === block);
                return [
                  blockDataForYear ? blockDataForYear.total_bookings : 0,
                  blockDataForYear ? blockDataForYear.under_one_year : 0
                ];
              }),
              yearData.total,
              yearData.under_one_year,
              (yearData.percentage_under_one_year ?? 0).toFixed(2),
              (yearData.percentage ?? 0).toFixed(2)
            ];
            allData.push(row);
          });
      });

      allData.push([]);
    }
    const res7 = await statistic7(startDate, endDate);
    const data7: BlockmonthData = res7.data
    const blocks7: string[] = res7.blocks
    if (data7 && blocks7) {
      const headers7 = [
        'Monat/Jahr',
        ...blocks7.map((block) => `Block ${block}`),
        'Gesamt'
      ];
      allData.push(["Anlage 4"]);
      allData.push(headers7);

      const rows7: (string | number)[][] = [];

      months.forEach((month, monthIndex) => {
        const yearsData = data7[month] || {};
        const allYears = Object.keys(yearsData).sort((a, b) => Number(b) - Number(a));

        allYears.forEach((year) => {
          const yearData = yearsData[year];
          const row = [
            `${month} ${year}`,
            ...blocks7.map((block) => {
              const blockDataForYear = yearData.blocks.find((b) => b.block === block);
              return blockDataForYear ? blockDataForYear.total_bookings : 0;
            }),
            yearData.total
          ];
          rows7.push(row);
        });
      });
      allData.push(...rows7);
      allData.push([])
    }

    const res8 = await statistic8(startDate, endDate);

    const data8: BlockmonthFacultyData = res8.data;
    const blocks8: string[] = res7.blocks;
    if (data8 && blocks8) {
      const headers8 = [
        'Monat/Jahr',
        ...blocks.map((block) => `Block ${block}`),
        'Gesamt',
        'davon U1'
      ];
      allData.push(["Anlage 4b"]);
      allData.push(headers8);

      const allMonthsAndYears: { month: string, year: string }[] = [];
      Object.entries(data8).forEach(([month, yearData]) => {
        Object.keys(yearData).forEach((year) => {
          allMonthsAndYears.push({ month, year });
        });
      });

      allMonthsAndYears.sort((a, b) => {
        if (a.year !== b.year) {
          return Number(b.year) - Number(a.year);
        }
        return months.indexOf(b.month) - months.indexOf(a.month);
      });
      const allPossibleMonthYearCombinations: { month: string, year: string }[] = [];
      months.forEach(month => {
        const yearsInData = Object.keys(data8[month] || {});
        yearsInData.forEach(year => {
          allPossibleMonthYearCombinations.push({ month, year });
        });
      });
      const rows8: (string | number)[][] = [];

      allMonthsAndYears.forEach(({ month, year }) => {
        const yearData = data8[month][year];

        const facultiesData = yearData.blocks.reduce((acc: { [faculty: string]: number }, block) => {
          Object.entries(block.faculties || {}).forEach(([faculty, count]) => {
            acc[faculty] = (acc[faculty] || 0) + count;
          });
          return acc;
        }, {});

        const row = [
          `${month} ${year}`,
          ...blocks.map((block) => {
            const blockDataForYear = yearData.blocks.find((b) => b.block === block);
            return blockDataForYear ? blockDataForYear.total_bookings : 0;
          }),
          yearData.total,
          yearData.under_one_year,
        ];
        rows8.push(row);

        Object.entries(facultiesData).forEach(([faculty, totalFacultyBookings], index) => {
          const facultyRow = [
            faculty,
            ...blocks.map((block) => {
              const blockDataForYear = yearData.blocks.find((b) => b.block === block);
              return blockDataForYear && blockDataForYear.faculties && blockDataForYear.faculties[faculty]
                ? blockDataForYear.faculties[faculty]
                : 0;
            }),
            totalFacultyBookings,
          ];
          rows8.push(facultyRow);
        });
      });

      allData.push(...rows8);
      allData.push([])
    }
    const res9 = await statistic9();
    const data9: Statistik9Data[] = res9.data;
    if (data9) {
      const headers9 = ['Year', 'Total Bookings'];

      allData.push(["Anlage 5"]);
      allData.push(headers9);

      const rows9: (string | number)[][] = data9.map((entry) => [
        entry.year,
        entry.total_bookings,
      ]);
      allData.push(...rows9);
      allData.push([]);
    }



    const csvContent = generateCSVContent(
      [],
      allData
    );
    downloadFile(csvContent, "AllData.csv");

  } catch (error) {
    console.error("Error downloading all data:", error);
  }
};

